import { render, staticRenderFns } from "./PsGroupsCropImage.vue?vue&type=template&id=17b2597e&scoped=true&"
import script from "./PsGroupsCropImage.vue?vue&type=script&lang=js&"
export * from "./PsGroupsCropImage.vue?vue&type=script&lang=js&"
import style0 from "./PsGroupsCropImage.vue?vue&type=style&index=0&id=17b2597e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2597e",
  null
  
)

export default component.exports